import type { SxProps, Theme } from '@mui/material/styles'

const CARD_BORDER_CREATE = '#e2e8f0'
const CARD_BORDER_ADMIN = '#e1e7f3'

export function resolveInstrumentTemplateLibraryCardSx(
  cardVariant: 'create' | 'admin' | 'bare',
): SxProps<Theme> | undefined {
  if (cardVariant === 'bare') {
    return undefined
  }
  if (cardVariant === 'admin') {
    return {
      bgcolor: '#ffffff',
      border: `1px solid ${CARD_BORDER_ADMIN}`,
      borderRadius: '10px',
      p: '25px 25px 24px',
    }
  }
  return {
    bgcolor: '#ffffff',
    border: `1px solid ${CARD_BORDER_CREATE}`,
    borderRadius: '10px',
    pt: '28px',
    px: '28px',
    pb: '28px',
  }
}
